import { Button, Card } from "react-bootstrap";
import { BadgeHd, CalculatorFill, Check2Square, Person, PersonBadge, Phone, TelephoneInboundFill, XCircle } from "react-bootstrap-icons";
import ModalCreateEditWorkItems from "../Projects/pages/ModalCreateEditWorkItems";
import { useState } from "react";

const CallInfoNotification = (props) => {
    const { notif, remove, openProfile, getDestUrl } = props;
    const [modalWorkItemData, setModalWorkItemData] = useState({ show: false });
    const goToEditPage = () => {
        remove(notif.ID);
        openProfile(notif.CallerInfoID, notif.Type);
    }
    function showModalWorkItemData() {
        let type = notif?.Type?.replace("_callinfo", "") ?? "";
        let gType = type;
        if (type === "staff" || type === "agent" || type === "personnel") {
            gType = "Staff";
        }
        setModalWorkItemData({
            show: true,
            title: `تماس ${notif.Name}`,
            entityType: type,
            entityGroupType: gType,
            entityId: notif.CallerInfoID
        })
    }
    return (
        <>
            <ModalCreateEditWorkItems modalData={modalWorkItemData} setModalData={setModalWorkItemData} />
            <Card className="notification-card">
                <Card.Header>
                    <label>
                        <TelephoneInboundFill color="#008074" />&nbsp; {notif.Title}
                    </label>
                    <label style={{ float: "left", marginRight: "20px" }} onClick={() => remove(notif.ID)}><XCircle color="red" size={17} style={{ cursor: "pointer" }} /></label>
                    <label style={{ float: "left", fontSize: "12px" }}>{"خط شماره: " + notif.LineNumber}</label>

                </Card.Header>
                <Card.Body className="row">
                    <div className="col-2 mt-1" ><Phone size={17} color="#c144d4" /></div><div className="col-9 mt-1"> {notif.CallNumber} </div>
                    <div className="col-2 mt-1" ><Person size={18} color="#003780" /></div><div className="col-9 mt-1"> {notif.Name} </div>
                    <div className="col-2 mt-1" ><CalculatorFill size={16} color="#7f4509" /></div><div className="col-9 mt-1" style={{ color: notif.RemainedAmountColor }}> {notif.RemainedAmountStr} </div>
                    <div className="mt-2 d-flex gap-1">
                        {Number(notif.CallerInfoID) > 0 &&
                            <>
                                <a href={getDestUrl(notif.CallerInfoID, notif.Type)}>
                                    <Button variant="outline-primary" className="tooltipBtn call-notif-btn" data-tooltip="پرونده مشتری" onClick={goToEditPage}>
                                        <PersonBadge size={25} />
                                    </Button>
                                </a>
                                <Button
                                    variant="outline-success"
                                    className="tooltipBtn call-notif-btn"
                                    onClick={showModalWorkItemData} data-tooltip="ثبت وظیفه">
                                    <Check2Square size={25} />
                                </Button>
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}
export default CallInfoNotification;